'use client';

import classNames from 'classnames';
import Image from 'next/image';
import { FC } from 'react';

import type { EventTeaListItem } from '@/entities/event';

import styles from './eventTeaCard.module.scss';

export interface EventTeaCardProps {
  tea: EventTeaListItem;
  className?: string;
}

const EventTeaCard: FC<EventTeaCardProps> = ({ tea, className }) => {
  return (
    <article className={classNames(styles.card, className)}>
      <div className={styles.card__image_wrap}>
        <Image
          fill
          alt={tea.title}
          className={styles.card__image}
          sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
          src={tea.image}
        />
      </div>
      <p className={styles.card__title}>{tea.title}</p>
    </article>
  );
};

export default EventTeaCard;
